import { Api } from '@axiom/ui';
import type { CompanySearchResult } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class LogoDevApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  async readSearchResults(query: string) {
    const trimmedQuery = query.trim();
    if (trimmedQuery.length === 0) return { data: [] as CompanySearchResult[] };

    return super.write<{ data: CompanySearchResult[] }>({
      endpoint: '/logo-dev/search',
      method: 'GET',
      query: { q: trimmedQuery },
      disableBlocker: true,
    });
  }
}

export const LogoDevApi = new LogoDevApiClass();
